import { Component, inject, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Marktlokation } from '../../../domain/model/marktlokation.model';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { SpannungsebeneItem } from '../../../domain/model/spannungsebene.enum';
import { UmspannungItem } from '../../../domain/model/umspannung.enum';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { MarktpartnerValidator } from '../validator/marktpartner.validator';
import { Feld } from '../../../domain/model/feld.enum';
import { MarktlokationIdValidator } from '../validator/marktlokation-id.validator';
import { EicCodeValidator } from '../validator/eic-code.validator';

@Component({
    selector: 'redispatch-marktlokation-sub-form',
    templateUrl: './marktlokation-sub-form.component.html',
    styleUrls: [
        './marktlokation-sub-form.component.scss',
    ],
    standalone: false,
})
export class MarktlokationSubFormComponent extends AbstractForm<Marktlokation> {

    public static readonly SHARED_MARKTLOKATION_VALIDATOR = MarktlokationIdValidator.validate();
    public static readonly SHARED_BILANZKREIS_VALIDATOR = EicCodeValidator.validate();
    public static readonly SHARED_LIEFERANT_VALIDATOR = MarktpartnerValidator.validateSingle();

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;

    public readonly MESSLOKATION_PATTERN = new RegExp('^[a-zA-Z]{2}[0-9]{11}[a-zA-Z0-9]{20}$');

    @Input({ required: true }) disabled: boolean;
    @Input({ required: true }) readonly: boolean;

    public readonly SpannungsebeneItems = SpannungsebeneItem.getAll();
    public readonly UmspannungItems = UmspannungItem.getAll();
    public readonly Feld = Feld;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<Marktlokation> {
        return {
            code: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    MarktlokationSubFormComponent.SHARED_MARKTLOKATION_VALIDATOR,
                ],
            ],
            bilanzkreis: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    MarktlokationSubFormComponent.SHARED_BILANZKREIS_VALIDATOR,
                ],
            ],
            spannungsebene: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                MatValidators.required,
            ],
            netzebeneDesNetzanschlusspunktes: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
            ],
            messlokationCode: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    Validators.pattern(this.MESSLOKATION_PATTERN),
                ],
            ],
            lieferant: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                MarktlokationSubFormComponent.SHARED_LIEFERANT_VALIDATOR,
            ],
        };
    }

    public sanitize(marktlokation: Marktlokation): Marktlokation {
        return marktlokation;
    }

}
